// Created By Sanjay // 27-01-25
import { axiosGetAuthorize, axiosGetAuthorizeMultiParams, axiosGetFileAuthorizeblob, axiosGetMultiParams, axiosPostAuthorize } from '../AxiosRequests';
import {
    ProcItemStockRegister,
    ProcItemStockRegister_TrackingDetails,
    ProcSelectAllRecord2GridviewSP,
    USP_Master_ItemSelectForItemStockAdjustment,
    USP_Master_ItemStockAdjustmentInsert,
    USP_Master_ItemUpdateStockAdjustment,
    USP_Master_ItemSelectForItemStockAdjustmentChangeAsPerDate,
    ProcItemStockRegister_ForMinimumStockLevel,
    ProcItemStockRegister_GroupWise,
    ProcItemStockRegisterTracking_ByItemGroup,
    ProcItemStockRegisterWithTotalAmount_ForAccount,
    ProcItemStockRegister_GroupWise_Dashboard,
    ProcItemStockRegister_ItemGroupWise,
    ProcItemStockRegisterTracking_ByItemCategory,
    GetAvailableReports,
    USP_Extra_UserFormsInsert,
    USP_Reports_TAXSummary_ALLRecords,
    USP_Reports_TAXSummary_ALLRecords_Sales,
    USP_Master_ItemGroupSelect,
    GetLedgerReportRecords,
    GetAdjustmentSelectById,
    USP_Master_ItemStockAdjustmentInsert_new,
    UpdateStatusForStockAdjustment,
    GetBalanceSheetReport,
    GetProfitLossReport,
    GetAccountHeadSummary,
    DownloadAdjustmentReport,
    DownloadIssueProcessEmployeeReportDateWise,
} from '../ApiEndPoints';

export default class DailyReportsServices {

    // async getMasterCompanyList(request) {
    //     return axiosGet(GetMasterCompanyList, request);
    // }
    async procItemStockRegister(request) {
        return axiosPostAuthorize(ProcItemStockRegister, request);
    }
    async procItemStockRegister_TrackingDetails(request) {
        return axiosPostAuthorize(ProcItemStockRegister_TrackingDetails, request);
    }
    async procSelectAllRecord2GridviewSP(request) {
        return axiosPostAuthorize(ProcSelectAllRecord2GridviewSP, request);
    }
    async usp_Master_ItemSelectForItemStockAdjustment(request) {
        return axiosGetAuthorize(USP_Master_ItemSelectForItemStockAdjustment, request);
    }
    async usp_Master_ItemStockAdjustmentInsert(request) {
        return axiosPostAuthorize(USP_Master_ItemStockAdjustmentInsert, request);
    }
    async usp_Master_ItemStockAdjustmentInsert_new(request) {
        return axiosPostAuthorize(USP_Master_ItemStockAdjustmentInsert_new, request);
    }
    async usp_Master_ItemUpdateStockAdjustment(request) {
        return axiosPostAuthorize(USP_Master_ItemUpdateStockAdjustment, request);
    }
    async usp_Master_ItemSelectForItemStockAdjustmentChangeAsPerDate(request) {
        return axiosPostAuthorize(USP_Master_ItemSelectForItemStockAdjustmentChangeAsPerDate, request);
    }
    async procItemStockRegister_ForMinimumStockLevel(request) {
        return axiosGetAuthorize(ProcItemStockRegister_ForMinimumStockLevel, request);
    }
    async procItemStockRegister_GroupWise(request) {
        return axiosPostAuthorize(ProcItemStockRegister_GroupWise, request);
    }
    async procItemStockRegisterTracking_ByItemGroup(request) {
        return axiosPostAuthorize(ProcItemStockRegisterTracking_ByItemGroup, request);
    }
    async procItemStockRegisterWithTotalAmount_ForAccount(request) {
        return axiosPostAuthorize(ProcItemStockRegisterWithTotalAmount_ForAccount, request);
    }
    async procItemStockRegister_GroupWise_Dashboard(request) {
        return axiosGetAuthorize(ProcItemStockRegister_GroupWise_Dashboard, request);
    }
    async procItemStockRegister_ItemGroupWise(request) {
        return axiosPostAuthorize(ProcItemStockRegister_ItemGroupWise, request);
    }
    async procItemStockRegisterTracking_ByItemCategory(request) {
        return axiosGetAuthorize(ProcItemStockRegisterTracking_ByItemCategory, request);
    }
    async getAvailableReports(request) {
        return axiosGetAuthorize(GetAvailableReports, request);
    }
    async usp_Extra_UserFormsInsert(request) {
        return axiosGetAuthorizeMultiParams(USP_Extra_UserFormsInsert, request);
    }
    async usp_Reports_TAXSummary_ALLRecords(request) {
        return axiosPostAuthorize(USP_Reports_TAXSummary_ALLRecords, request);
    }
    async usp_Reports_TAXSummary_ALLRecords_Sales(request) {
        return axiosPostAuthorize(USP_Reports_TAXSummary_ALLRecords_Sales, request);
    }
    async usp_Master_ItemGroupSelect(request) {
        return axiosGetAuthorize(USP_Master_ItemGroupSelect, request);
    }
    async getLedgerReportRecords(request) {
        return axiosPostAuthorize(GetLedgerReportRecords, request);
    }
    async getAccountHeadSummary(request) {
        return axiosPostAuthorize(GetAccountHeadSummary, request);
    }
    async getAdjustmentSelectById(request) {
        return axiosGetAuthorize(GetAdjustmentSelectById, request);
    }
    async updateStatusForStockAdjustment(request) {
        return axiosGetMultiParams(UpdateStatusForStockAdjustment, request);
    }
    async downloadAdjustmentReport(request) {
        return axiosGetFileAuthorizeblob(DownloadAdjustmentReport, request);
    }
    async getBalanceSheetReport(request) {
        return axiosPostAuthorize(GetBalanceSheetReport, request);
    }
    async getProfitLossReport(request) {
        return axiosPostAuthorize(GetProfitLossReport, request);
    }
    async downloadIssueProcessEmployeeReportDateWise(request) {
        return axiosPostAuthorize(DownloadIssueProcessEmployeeReportDateWise, request);
    }
}